import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
// api
import { getSingleActivityData } from '../api';
// react router
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// hooks
import useSettings from '@/hooks/useSettings';
// components
import { Page, HeaderBreadcrumbs } from '@/components';
// custom components
import ActivityTypesCreateEdit from './ActivityTypesCreateEdit';
// types
import type { ActivityType } from '../types';
// paths
import { PATH_SETTINGS, ROOTS_SETTINGS } from '../routes/paths';
import { PATH_USER } from '@/features/app';

// ----------------------------------------------------------------------

export default function ActivityTypesCreate() {
  const { themeStretch } = useSettings();
  const [currentData, setCurrentData] = useState<ActivityType | {}>({});

  const { pathname } = useLocation();

  const { id } = useParams();

  const isEdit = pathname.includes('edit');

  useEffect(() => {
    const fetchData = async () => {
      const data = await getSingleActivityData(Number(id));
      setCurrentData(data);
    };

    id && fetchData();
  }, [id]);

  return (
    <Page title="Create or Edit activity type">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={!isEdit ? 'Add activity type' : 'Edit activity type'}
          links={[
            { name: 'Dashboard', href: PATH_USER.root },
            {
              name: 'Settings',
              href: `${ROOTS_SETTINGS}${PATH_SETTINGS.leads}`,
            },
            {
              name: 'Leads',
              href: `${ROOTS_SETTINGS}${PATH_SETTINGS.leads}`,
            },
            {
              name: !isEdit
                ? 'Add New Activity Type'
                : isEmpty(currentData)
                ? ''
                : (currentData as ActivityType).name,
            },
          ]}
        />
        <ActivityTypesCreateEdit
          currentData={currentData as ActivityType}
          ID={Number(id)}
        />
      </Container>
    </Page>
  );
}
